import React from "react";
// @ts-ignore
import styles from "./ContentCard.module.scss";

interface Props{
	children: React.ReactElement | React.ReactElement[];
}

const ContentCard: React.FC<Props> = ({children}) => {
	return (
		<div className={styles.wrapper}>
			{children}
		</div>
	)
}

export default ContentCard;
